module.exports = __webpack_public_path__ + "img/86.3462a49e.jpg";